module.exports = __webpack_public_path__ + "img/TR.aaf65b48.svg";